import React from 'react';
import { useInView } from '../hooks/useInView';

const OtherExperienceItem = ({ experience, monthNames }) => {
    const { ref, inView } = useInView();
    
    const startDate = new Date(experience.start_date.seconds * 1000);
    const stringStartDate = `${monthNames[startDate.getMonth()]} ${startDate.getFullYear()}`;
    const endDate = new Date(experience.end_date.seconds * 1000);
    let stringEndDate = endDate.getFullYear() < startDate.getFullYear() ? "Present" : `${monthNames[endDate.getMonth()]} ${endDate.getFullYear()}`;

    return (
        <div
            ref={ref}
            className={`experience-item fade-in-up hover-scale ${inView ? 'animation-active' : ''}`}>
            <p className='experience-company'>{experience.name}</p>
            <p className='experience-role'>{experience.role}</p>
            <p className='experience-date'>{stringStartDate} - {stringEndDate}</p>
            <p className='experience-desription'>{experience.description}</p>
        </div>
    );
};

export default OtherExperienceItem;
